


































import Vue from 'vue';
import axios from 'axios';
import CreatePDF from '../components/CreatePDF.vue';
import { buildPagination, buildPaginationOpenEnded } from '../utils/pagination';

export default Vue.extend({
    name: 'Submissions',
    components: {
        CreatePdf: CreatePDF
    },
    data() {
        return {
            submissions: [] as any[],
            searchResultSubmissions: [] as any[],
            isSearchResult: false,
            isSearching: false,
            currentPageNum: 1 as number,
            searchQ: '',
            numItems: 5,
            pagination: [] as (number | '...')[],
            afterTokens: [ '' ],
            hasMore: true,
            showCreatePDF: false,
            selectedSubmission: {} as any,
        }
    },
    created() {        
        this.getSubmissions()
            .then(() => {
                this.$store.state.routeLoaded = true;
            });
    },
    methods: {
        async getSubmissions() {
            this.isSearchResult = false;
            const after = this.afterTokens[this.currentPageNum - 1];
            const url = `${this.$store.state.apiUrl}/forms/submissions/${this.$route.params.formId}?after=${after}&numItems=${this.numItems}`;
            await axios.get(url)
                .then(resp => {
                    this.submissions = [];
                    resp.data.submissions.forEach((s: any) => {
                        let preview = '';
                        for(let i = 0; i < 5; i++) {
                            if(!s.values[i]) break;
                            preview += s.values[i].name + ": " + s.values[i].value.substring(0, 50) + '<br>';
                        }
                        s.preview = preview;
                        s.submittedAtString = new Date(s.submittedAt).toLocaleDateString();
                        this.submissions.push(s);
                    });
                    this.afterTokens[this.currentPageNum] = resp.data.after;
                    const hasNextPage = !!(resp.data.after && resp.data.submissions.length == this.numItems);
                    this.pagination = buildPaginationOpenEnded(this.currentPageNum, hasNextPage);
                })
                .catch(e => {
                    console.log(e);
                });
        },
        clearSearch() {
            this.searchQ = '';
            this.searchSubmissions();
        },
        async searchSubmissions() {
            this.currentPageNum = 1;
            if(!this.searchQ) {
                this.getSubmissions();
                return;
            }
            this.isSearching = true;
            this.isSearchResult = true;
            const url = `${this.$store.state.apiUrl}/forms/submissions/search/${this.$route.params.formId}?searchQ=${this.searchQ}`;
            await axios.get(url)
                .then(resp => {
                    this.submissions = [];
                    this.searchResultSubmissions = [];
                    resp.data.forEach((s: any) => {
                        let preview = '';
                        for(let i = 0; i < 5; i++) {
                            if(!s.values[i]) break;
                            preview += s.values[i].name + ": " + s.values[i].value.substring(0, 50) + '<br>';
                        }
                        s.preview = preview;
                        s.submittedAtString = new Date(s.submittedAt).toLocaleDateString();

                        this.searchResultSubmissions.push(s);
                    });
                    this.submissions = this.searchResultSubmissions.slice(0, this.numItems);
                    this.pagination = buildPagination(this.currentPageNum, Math.ceil(this.searchResultSubmissions.length / this.numItems));
                })
                .catch(e => {
                    console.log(e);
                });
            this.isSearching = false;
        },
        changePage(num: number) {
            this.currentPageNum = num;
            if(this.isSearchResult) {
                this.submissions = this.searchResultSubmissions.slice((this.numItems * (this.currentPageNum - 1)), (this.numItems * this.currentPageNum));
                this.pagination = buildPagination(this.currentPageNum, Math.ceil(this.searchResultSubmissions.length / this.numItems));
            } else {
                this.getSubmissions();
            }
        },
        createPDF(submission: any) {
            console.log(submission);
            this.selectedSubmission = submission;
            this.showCreatePDF = true;
        },
        closeCreatePDF() {
          this.showCreatePDF = false;
        },
        backToForms() {
            if(this.$route.query.lastPage) {
                this.$router.push('/forms?page=' + this.$route.query.lastPage);
            } else {
                this.$router.push('/forms');
            }
        }
    }
})
